/**
 * 非对称加密-RSA
 * 前端公钥加密 - 后端私钥解密
 *
 */
import JSEncrypt from 'jsencrypt'

const PUBLIC_KEY =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC/K5eyJ18Y2l/vgGClKLXGQ0oAO2YdZleu59Oh2wlrxcxgKmt6FJ6rjxDJhs3K3uHdjvZWJnIQjd+pkc0g2/Yh+n5el7zWTWavUQ+q/mMIIIubiDvIJrECPj8thFy7LMFqrM2Qek8wdGV5lPMn/Yq6siidALJwOrt+UBehcwoV2QIDAQAB'

export default ({ app }, inject) => {
  /**
   * 真实代码
   *  const RSAENCRY = {
        RSAencrypt(pas) {
          let key = PUBLIC_KEY
          if (typeof window !== 'undefined') {
            key = key.substring(0, 34) + app.store.getters['turingKey']
          }
          let jse = new JSEncrypt()
          jse.setPublicKey(key)
          return jse.encrypt(pas)
        }
        
      }
   */
  var encode_version = 'jsjiami.com.v5',
    xncaz = '__0xfd2f6',
    __0xfd2f6 = [
      'w6XDtS1/w47Dn8OF',
      'wrzChsOj',
      'H8KCAsK0Mm5Sw7LDhA==',
      'YyXCvw==',
      'wqjCjMOwwqjCo0dlOWw=',
      'PTQxw4bDuFXDtELCpzLDrsOQXAw=',
      '5Ymn6Zup54mT5p2a5Yyj7766w4DChOS/veWspOafvuW8rueoog==',
      'QsKlwrA=',
      'bh/CnMK+ZQ==',
      'w43CmcOpw6MJVcOow7fCgw==',
      'UynDu8OIwoc=',
      'BnJGH8Ov',
      'HgArw5bDlA==',
      'w5DDlG/Ci8OJ',
      'w4XCpMK4asOs',
      'X8KBwrUnCg==',
      'EcOdWhLCmg==',
      'TsODw484Eg==',
      'TzfDocO/Iw==',
      'D8KcBApmw4tjLMKmw51eJQ==',
      '54mC5pyK5Y+l772Cw44T5L+p5ayE5p6g5b+x56mc77646Ly26K+P5pSJ5o+e5oib5Lqt55iu5bes5L+P',
      'woRzw6MPDw==',
      'bMK+EMK3VA==',
      'aMOEw4UZElQEWcOw',
      'OMOjw67DoMKNZ8KmasOq',
      'AsO1w4Ideg==',
      'wq5mw6AREDLDtw==',
      'wqHCjk45OQ=='
    ]
  ;(function (_0x5ccd15, _0x15e93a) {
    var _0x23750b = function (_0x4ac0eb) {
      while (--_0x4ac0eb) {
        _0x5ccd15['push'](_0x5ccd15['shift']())
      }
    }
    _0x23750b(++_0x15e93a)
  })(__0xfd2f6, 0x112)
  var _0x2dcf = function (_0x360c14, _0x232541) {
    _0x360c14 = _0x360c14 - 0x0
    var _0x12882b = __0xfd2f6[_0x360c14]
    if (_0x2dcf['initialized'] === undefined) {
      ;(function () {
        var _0x1c543b = typeof window !== 'undefined' ? window : typeof process === 'object' && typeof require === 'function' && typeof global === 'object' ? global : this
        var _0x360db9 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        _0x1c543b['atob'] ||
          (_0x1c543b['atob'] = function (_0x3f7313) {
            var _0x2c2b15 = String(_0x3f7313)['replace'](/=+$/, '')
            for (
              var _0x592444 = 0x0, _0x100cd, _0xd5b517, _0xe053e3 = 0x0, _0x1736a1 = '';
              (_0xd5b517 = _0x2c2b15['charAt'](_0xe053e3++));
              ~_0xd5b517 && ((_0x100cd = _0x592444 % 0x4 ? _0x100cd * 0x40 + _0xd5b517 : _0xd5b517), _0x592444++ % 0x4)
                ? (_0x1736a1 += String['fromCharCode'](0xff & (_0x100cd >> ((-0x2 * _0x592444) & 0x6))))
                : 0x0
            ) {
              _0xd5b517 = _0x360db9['indexOf'](_0xd5b517)
            }
            return _0x1736a1
          })
      })()
      var _0x1c0101 = function (_0x729a89, _0x31a311) {
        var _0x115fc2 = [],
          _0x3b3e89 = 0x0,
          _0x5bff03,
          _0x19e02a = '',
          _0x2aa72d = ''
        _0x729a89 = atob(_0x729a89)
        for (var _0x4bea71 = 0x0, _0x341789 = _0x729a89['length']; _0x4bea71 < _0x341789; _0x4bea71++) {
          _0x2aa72d += '%' + ('00' + _0x729a89['charCodeAt'](_0x4bea71)['toString'](0x10))['slice'](-0x2)
        }
        _0x729a89 = decodeURIComponent(_0x2aa72d)
        for (var _0x150a11 = 0x0; _0x150a11 < 0x100; _0x150a11++) {
          _0x115fc2[_0x150a11] = _0x150a11
        }
        for (_0x150a11 = 0x0; _0x150a11 < 0x100; _0x150a11++) {
          _0x3b3e89 = (_0x3b3e89 + _0x115fc2[_0x150a11] + _0x31a311['charCodeAt'](_0x150a11 % _0x31a311['length'])) % 0x100
          _0x5bff03 = _0x115fc2[_0x150a11]
          _0x115fc2[_0x150a11] = _0x115fc2[_0x3b3e89]
          _0x115fc2[_0x3b3e89] = _0x5bff03
        }
        _0x150a11 = 0x0
        _0x3b3e89 = 0x0
        for (var _0x1e191b = 0x0; _0x1e191b < _0x729a89['length']; _0x1e191b++) {
          _0x150a11 = (_0x150a11 + 0x1) % 0x100
          _0x3b3e89 = (_0x3b3e89 + _0x115fc2[_0x150a11]) % 0x100
          _0x5bff03 = _0x115fc2[_0x150a11]
          _0x115fc2[_0x150a11] = _0x115fc2[_0x3b3e89]
          _0x115fc2[_0x3b3e89] = _0x5bff03
          _0x19e02a += String['fromCharCode'](_0x729a89['charCodeAt'](_0x1e191b) ^ _0x115fc2[(_0x115fc2[_0x150a11] + _0x115fc2[_0x3b3e89]) % 0x100])
        }
        return _0x19e02a
      }
      _0x2dcf['rc4'] = _0x1c0101
      _0x2dcf['data'] = {}
      _0x2dcf['initialized'] = !![]
    }
    var _0x5446cb = _0x2dcf['data'][_0x360c14]
    if (_0x5446cb === undefined) {
      if (_0x2dcf['once'] === undefined) {
        _0x2dcf['once'] = !![]
      }
      _0x12882b = _0x2dcf['rc4'](_0x12882b, _0x232541)
      _0x2dcf['data'][_0x360c14] = _0x12882b
    } else {
      _0x12882b = _0x5446cb
    }
    return _0x12882b
  }
  const TURING = {
    ['Clouse'](_0x1780cc) {
      var _0x68b86a = {
        kWqUZ: function _0x2cf404(_0x3a192b, _0x3cd15a) {
          return _0x3a192b !== _0x3cd15a
        },
        zVtzp: function _0x1cb95c(_0x565cf2, _0x3272fe) {
          return _0x565cf2 + _0x3272fe
        },
        sHQtz: 'turingKey'
      }
      let _0x19c76a = PUBLIC_KEY
      if (_0x68b86a[_0x2dcf('0x0', 'K0eg')](typeof window, _0x2dcf('0x1', 'p8WH'))) {
        _0x19c76a = _0x68b86a['zVtzp'](_0x19c76a[_0x2dcf('0x2', 'GP]s')](0x0, 0x22), app[_0x2dcf('0x3', '*ulC')][_0x2dcf('0x4', 'iqJG')][_0x68b86a[_0x2dcf('0x5', 'EZq2')]])
      }
      let _0xfa5e94 = new JSEncrypt()
      _0xfa5e94[
        (![] + [])[!+[] + !![] + !![]] +
          ([][[]] + [])[!+[] + !![] + !![]] +
          (!![] + [])[+[]] +
          [][(![] + [])[!+[] + !![] + !![]] + ([] + {})[+!![]] + (!![] + [])[+!![]] + (!![] + [])[+[]]][
            ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
              ([] + {})[+!![]] +
              ([][[]] + [])[+!![]] +
              (![] + [])[!+[] + !![] + !![]] +
              (!![] + [])[+[]] +
              (!![] + [])[+!![]] +
              ([][[]] + [])[+[]] +
              ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
              (!![] + [])[+[]] +
              ([] + {})[+!![]] +
              (!![] + [])[+!![]]
          ](
            (!![] + [])[+!![]] +
              ([][[]] + [])[!+[] + !![] + !![]] +
              (!![] + [])[+[]] +
              ([][[]] + [])[+[]] +
              (!![] + [])[+!![]] +
              ([][[]] + [])[+!![]] +
              ([] + {})[!+[] + !![] + !![] + !![] + !![] + !![] + !![]] +
              ([][[]] + [])[+[]] +
              ([][[]] + [])[+!![]] +
              ([][[]] + [])[!+[] + !![] + !![]] +
              (![] + [])[!+[] + !![] + !![]] +
              ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
              (+{} + [])[+!![]] +
              ([] +
                [][(![] + [])[!+[] + !![] + !![]] + ([] + {})[+!![]] + (!![] + [])[+!![]] + (!![] + [])[+[]]][
                  ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                    ([] + {})[+!![]] +
                    ([][[]] + [])[+!![]] +
                    (![] + [])[!+[] + !![] + !![]] +
                    (!![] + [])[+[]] +
                    (!![] + [])[+!![]] +
                    ([][[]] + [])[+[]] +
                    ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                    (!![] + [])[+[]] +
                    ([] + {})[+!![]] +
                    (!![] + [])[+!![]]
                ](
                  (!![] + [])[+!![]] +
                    ([][[]] + [])[!+[] + !![] + !![]] +
                    (!![] + [])[+[]] +
                    ([][[]] + [])[+[]] +
                    (!![] + [])[+!![]] +
                    ([][[]] + [])[+!![]] +
                    ([] + {})[!+[] + !![] + !![] + !![] + !![] + !![] + !![]] +
                    (![] + [])[!+[] + !![]] +
                    ([] + {})[+!![]] +
                    ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                    (+{} + [])[+!![]] +
                    (!![] + [])[+[]] +
                    ([][[]] + [])[!+[] + !![] + !![] + !![] + !![]] +
                    ([] + {})[+!![]] +
                    ([][[]] + [])[+!![]]
                )(!+[] + !![] + !![] + !![] + !![] + !![]))[!+[] + !![] + !![]] +
              ([][[]] + [])[!+[] + !![] + !![]]
          )(!+[] + !![] + !![] + !![] + !![] + !![])(
            [][(![] + [])[!+[] + !![] + !![]] + ([] + {})[+!![]] + (!![] + [])[+!![]] + (!![] + [])[+[]]][
              ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                ([] + {})[+!![]] +
                ([][[]] + [])[+!![]] +
                (![] + [])[!+[] + !![] + !![]] +
                (!![] + [])[+[]] +
                (!![] + [])[+!![]] +
                ([][[]] + [])[+[]] +
                ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                (!![] + [])[+[]] +
                ([] + {})[+!![]] +
                (!![] + [])[+!![]]
            ](
              (!![] + [])[+!![]] +
                ([][[]] + [])[!+[] + !![] + !![]] +
                (!![] + [])[+[]] +
                ([][[]] + [])[+[]] +
                (!![] + [])[+!![]] +
                ([][[]] + [])[+!![]] +
                ([] + {})[!+[] + !![] + !![] + !![] + !![] + !![] + !![]] +
                ([][[]] + [])[!+[] + !![] + !![]] +
                (![] + [])[!+[] + !![] + !![]] +
                ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                (+{} + [])[+!![]] +
                ([] +
                  [][(![] + [])[!+[] + !![] + !![]] + ([] + {})[+!![]] + (!![] + [])[+!![]] + (!![] + [])[+[]]][
                    ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                      ([] + {})[+!![]] +
                      ([][[]] + [])[+!![]] +
                      (![] + [])[!+[] + !![] + !![]] +
                      (!![] + [])[+[]] +
                      (!![] + [])[+!![]] +
                      ([][[]] + [])[+[]] +
                      ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                      (!![] + [])[+[]] +
                      ([] + {})[+!![]] +
                      (!![] + [])[+!![]]
                  ](
                    (!![] + [])[+!![]] +
                      ([][[]] + [])[!+[] + !![] + !![]] +
                      (!![] + [])[+[]] +
                      ([][[]] + [])[+[]] +
                      (!![] + [])[+!![]] +
                      ([][[]] + [])[+!![]] +
                      ([] + {})[!+[] + !![] + !![] + !![] + !![] + !![] + !![]] +
                      (![] + [])[!+[] + !![]] +
                      ([] + {})[+!![]] +
                      ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                      (+{} + [])[+!![]] +
                      (!![] + [])[+[]] +
                      ([][[]] + [])[!+[] + !![] + !![] + !![] + !![]] +
                      ([] + {})[+!![]] +
                      ([][[]] + [])[+!![]]
                  )(!+[] + !![] + !![] + !![] + !![] + !![]))[!+[] + !![] + !![]] +
                ([][[]] + [])[!+[] + !![] + !![]]
            )(!+[] + !![] + !![] + !![] + !![] + !![] + !![] + !![])(([] + {})[+[]])[+[]] +
              (!+[] + !![] + !![] + !![] + !![] + []) +
              (+[] + [])
          ) +
          ([][[]] + [])[+[]] +
          ([] + {})[!+[] + !![]] +
          (![] + [])[!+[] + !![]] +
          ([][[]] + [])[!+[] + !![] + !![] + !![] + !![]] +
          ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
          [][(![] + [])[!+[] + !![] + !![]] + ([] + {})[+!![]] + (!![] + [])[+!![]] + (!![] + [])[+[]]][
            ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
              ([] + {})[+!![]] +
              ([][[]] + [])[+!![]] +
              (![] + [])[!+[] + !![] + !![]] +
              (!![] + [])[+[]] +
              (!![] + [])[+!![]] +
              ([][[]] + [])[+[]] +
              ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
              (!![] + [])[+[]] +
              ([] + {})[+!![]] +
              (!![] + [])[+!![]]
          ](
            (!![] + [])[+!![]] +
              ([][[]] + [])[!+[] + !![] + !![]] +
              (!![] + [])[+[]] +
              ([][[]] + [])[+[]] +
              (!![] + [])[+!![]] +
              ([][[]] + [])[+!![]] +
              ([] + {})[!+[] + !![] + !![] + !![] + !![] + !![] + !![]] +
              ([][[]] + [])[+[]] +
              ([][[]] + [])[+!![]] +
              ([][[]] + [])[!+[] + !![] + !![]] +
              (![] + [])[!+[] + !![] + !![]] +
              ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
              (+{} + [])[+!![]] +
              ([] +
                [][(![] + [])[!+[] + !![] + !![]] + ([] + {})[+!![]] + (!![] + [])[+!![]] + (!![] + [])[+[]]][
                  ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                    ([] + {})[+!![]] +
                    ([][[]] + [])[+!![]] +
                    (![] + [])[!+[] + !![] + !![]] +
                    (!![] + [])[+[]] +
                    (!![] + [])[+!![]] +
                    ([][[]] + [])[+[]] +
                    ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                    (!![] + [])[+[]] +
                    ([] + {})[+!![]] +
                    (!![] + [])[+!![]]
                ](
                  (!![] + [])[+!![]] +
                    ([][[]] + [])[!+[] + !![] + !![]] +
                    (!![] + [])[+[]] +
                    ([][[]] + [])[+[]] +
                    (!![] + [])[+!![]] +
                    ([][[]] + [])[+!![]] +
                    ([] + {})[!+[] + !![] + !![] + !![] + !![] + !![] + !![]] +
                    (![] + [])[!+[] + !![]] +
                    ([] + {})[+!![]] +
                    ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                    (+{} + [])[+!![]] +
                    (!![] + [])[+[]] +
                    ([][[]] + [])[!+[] + !![] + !![] + !![] + !![]] +
                    ([] + {})[+!![]] +
                    ([][[]] + [])[+!![]]
                )(!+[] + !![] + !![] + !![] + !![] + !![]))[!+[] + !![] + !![]] +
              ([][[]] + [])[!+[] + !![] + !![]]
          )(!+[] + !![] + !![] + !![] + !![] + !![])(
            [][(![] + [])[!+[] + !![] + !![]] + ([] + {})[+!![]] + (!![] + [])[+!![]] + (!![] + [])[+[]]][
              ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                ([] + {})[+!![]] +
                ([][[]] + [])[+!![]] +
                (![] + [])[!+[] + !![] + !![]] +
                (!![] + [])[+[]] +
                (!![] + [])[+!![]] +
                ([][[]] + [])[+[]] +
                ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                (!![] + [])[+[]] +
                ([] + {})[+!![]] +
                (!![] + [])[+!![]]
            ](
              (!![] + [])[+!![]] +
                ([][[]] + [])[!+[] + !![] + !![]] +
                (!![] + [])[+[]] +
                ([][[]] + [])[+[]] +
                (!![] + [])[+!![]] +
                ([][[]] + [])[+!![]] +
                ([] + {})[!+[] + !![] + !![] + !![] + !![] + !![] + !![]] +
                ([][[]] + [])[!+[] + !![] + !![]] +
                (![] + [])[!+[] + !![] + !![]] +
                ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                (+{} + [])[+!![]] +
                ([] +
                  [][(![] + [])[!+[] + !![] + !![]] + ([] + {})[+!![]] + (!![] + [])[+!![]] + (!![] + [])[+[]]][
                    ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                      ([] + {})[+!![]] +
                      ([][[]] + [])[+!![]] +
                      (![] + [])[!+[] + !![] + !![]] +
                      (!![] + [])[+[]] +
                      (!![] + [])[+!![]] +
                      ([][[]] + [])[+[]] +
                      ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                      (!![] + [])[+[]] +
                      ([] + {})[+!![]] +
                      (!![] + [])[+!![]]
                  ](
                    (!![] + [])[+!![]] +
                      ([][[]] + [])[!+[] + !![] + !![]] +
                      (!![] + [])[+[]] +
                      ([][[]] + [])[+[]] +
                      (!![] + [])[+!![]] +
                      ([][[]] + [])[+!![]] +
                      ([] + {})[!+[] + !![] + !![] + !![] + !![] + !![] + !![]] +
                      (![] + [])[!+[] + !![]] +
                      ([] + {})[+!![]] +
                      ([] + {})[!+[] + !![] + !![] + !![] + !![]] +
                      (+{} + [])[+!![]] +
                      (!![] + [])[+[]] +
                      ([][[]] + [])[!+[] + !![] + !![] + !![] + !![]] +
                      ([] + {})[+!![]] +
                      ([][[]] + [])[+!![]]
                  )(!+[] + !![] + !![] + !![] + !![] + !![]))[!+[] + !![] + !![]] +
                ([][[]] + [])[!+[] + !![] + !![]]
            )(!+[] + !![] + !![] + !![] + !![] + !![] + !![] + !![])(([] + {})[+[]])[+[]] +
              (!+[] + !![] + !![] + !![] + []) +
              ([] + {})[!+[] + !![]]
          ) +
          ([][[]] + [])[!+[] + !![] + !![]] +
          (+(+!![] + ([][[]] + [])[!+[] + !![] + !![]] + (+!![] + []) + (+[] + []) + (+[] + []) + (+[] + [])) + [])[!+[] + !![] + !![] + !![] + !![] + !![] + !![]]
      ](_0x19c76a)
      return _0xfa5e94[_0x2dcf('0x6', 'hH)o')](_0x1780cc)
    }
  }
  ;(function (_0x3ca7c4, _0x9e6266, _0x149d09) {
    var _0x32be63 = {
      jcyEn: function _0x130fef(_0x52e85f, _0x2c4409) {
        return _0x52e85f === _0x2c4409
      },
      hHWaA: _0x2dcf('0x7', '3Hqx'),
      iXHYX: _0x2dcf('0x8', 'o8UI'),
      IGpyM: _0x2dcf('0x9', '7!q@'),
      FALSG: function _0xffa719(_0x258e24, _0x59908b) {
        return _0x258e24 !== _0x59908b
      },
      VPAdN: _0x2dcf('0xa', '3Hqx'),
      RinyX: _0x2dcf('0xb', 'iK8e'),
      SinDf: function _0x1d23ac(_0xf05b46, _0x3f9728) {
        return _0xf05b46 + _0x3f9728
      },
      Mpwjz: _0x2dcf('0xc', 'c8kY')
    }
    _0x149d09 = 'al'
    try {
      if (_0x32be63['jcyEn'](_0x2dcf('0xd', 'm)!z'), _0x32be63[_0x2dcf('0xe', '7!q@')])) {
        key = key[_0x2dcf('0xf', 'ROtq')](0x0, 0x22) + app[_0x2dcf('0x10', 'MnWe')]['getters'][_0x32be63[_0x2dcf('0x11', 'h1eN')]]
      } else {
        _0x149d09 += _0x32be63[_0x2dcf('0x12', 'iK8e')]
        _0x9e6266 = encode_version
        if (!(_0x32be63[_0x2dcf('0x13', 'DeLF')](typeof _0x9e6266, _0x32be63['VPAdN']) && _0x9e6266 === _0x32be63['RinyX'])) {
          if (_0x32be63[_0x2dcf('0x14', '5m^0')]('Ubf', 'IBE')) {
            let _0x4c4bc7 = PUBLIC_KEY
            if (_0x32be63[_0x2dcf('0x15', 'Gprt')](typeof window, _0x32be63[_0x2dcf('0x16', 'c8kY')])) {
              _0x4c4bc7 = _0x32be63[_0x2dcf('0x17', 'p8WH')](_0x4c4bc7['substring'](0x0, 0x22), app['store']['getters'][_0x32be63[_0x2dcf('0x18', 'TUsa')]])
            }
            let _0x275141 = new JSEncrypt()
            _0x275141[_0x2dcf('0x19', 'cG&G')](_0x4c4bc7)
            return _0x275141['encrypt'](pas)
          } else {
            _0x3ca7c4[_0x149d09]('删除' + _0x2dcf('0x1a', 'unHp'))
          }
        }
      }
    } catch (_0x289df8) {
      _0x3ca7c4[_0x149d09](_0x32be63[_0x2dcf('0x1b', 'iqJG')])
    }
  })(window)
  encode_version = 'jsjiami.com.v5'
  inject('TURINGOFFRONT', TURING)
}
